<template>
  <div class="addDepart">
    <el-card class="filter-card">
      <div slot="header" class="clearfix">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/sys/group">部门管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="系统" prop="companyId">
          <el-select v-model="ruleForm.companyId" placeholder="请选择系统" filterable clearable @change="systemChange" style="width: 500px;">
            <el-option
              v-for="item in companyOptions"
              :key="item.companyId"
              :label="item.companyName"
              :value="item.companyId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上级部门" prop="groupParentId" v-if="departTreeList.length || ruleForm.groupParentId">
            <el-input v-model="ruleForm.groupParentName" @focus="selectSuperDepart" placeholder="请选择上级部门" style="width: 500px;"></el-input>
        </el-form-item>
        <el-form-item label="部门名称" prop="groupName">
            <el-input v-model="ruleForm.groupName" placeholder="请输入部门名称" style="width: 500px;"></el-input>
        </el-form-item>
        <el-form-item label="显示顺序" prop="sortNo">
            <el-input v-model="ruleForm.sortNo" placeholder="请输入显示顺序" style="width: 500px;"></el-input>
        </el-form-item>
        <el-form-item label="部门类型" prop="groupTypeId">
            <el-input v-model="ruleForm.groupTypeId" placeholder="请输入部门类型" style="width: 500px;"></el-input>
        </el-form-item>
        <el-form-item label="部门描述" prop="groupDesc">
            <el-input v-model="ruleForm.groupDesc" placeholder="请输入部门描述" style="width: 500px;"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer-btn">
        <el-button icon="el-icon-close" type="danger" size="small" @click="$router.back()">取 消</el-button>
        <el-button icon="el-icon-plus" type="primary" size="small" @click="addDepartItem('ruleForm')">确 认</el-button>
      </div>
    </el-card>
    <el-dialog
      title="上级部门"
      :visible.sync="dialogVisible"
      append-to-body
      width="30%"
      top="5vh"
      :before-close="handleClose"
    >
      <el-tree
        :data="departTreeList"
        show-checkbox
        node-key="groupId"
        ref="tree"
        highlight-current
        check-strictly
        @check-change="checkChange"
        :props="defaultProps">
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDepartInfoLists, addDepart, changeDepart } from '@/api/departMange';
import { getSystemData } from '@/api/systemMange';
import { dateFilter } from '@/utils';
export default {
  data () {
    return {
      dialogVisible: false, // 选择上级部门dialog
      title: '',
      companyOptions: [], // 所有系统
      departTreeList: [], // 上级部门列表
      defaultProps: {
        children: 'children',
        label: 'groupName'
      },
      ruleForm: {
        companyId: '',          // 系统ID
        groupParentId: 0,       // 父级部门ID
        groupParentName: '',    //
        groupDesc: '',          // 部门描述
        groupName: '',          // 部门名称
        groupTypeId: '',        // 部门类型
        sortNo: '',             // 排序
        userCode: ''            // 登陆用户ID
      },
      rules: {
          companyId: [
              { required: true, message: '请选择系统', trigger: 'blur' }
          ],
          groupParentId: [
              { required: true, message: '请选择上级部门', trigger: 'blur' }
          ],
          groupName: [
              { required: true, message: '请输入部门名称', trigger: 'blur' }
          ],
          sortNo: [
              { required: true, message: '请选输入显示排序', trigger: 'blur' }
          ]
      },
      searchSystemParams: {
        pageNo: 1,
        pageSize: 100,
        companyName: '',
        userCode: ''
      },
    };
  },
  created(){
    if(this.$route.query.item){
      this.title = "编辑部门"
      this.ruleForm = JSON.parse(this.$route.query.item)
    }else{
      this.title = "新增部门"
    }
    this.getAllSystemInfo()
  },
  methods: {
    // 查询所有系统信息
    async getAllSystemInfo(){
      this.searchSystemParams.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId.toString()
      const res = await getSystemData(this.searchSystemParams);
      if(res.code == 200){
        this.companyOptions = res.data.list
      }else{
        this.$message.error(res.msg)
      }
    },
    // 新增部门选择系统
    systemChange(e){
      this.ruleForm.companyId = e;
      if(e){
        this.getDepartList()
      }
    },
    selectSuperDepart(){
      if(!this.ruleForm.companyId){
        this.$message.warning("请先选择系统")
        return
      }
      this.dialogVisible = true
    },
    // 查询所有部门信息
    async getDepartList(){
      this.loading = true
      this.departTreeList = []
      this.ruleForm.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
      const res = await getDepartInfoLists(this.ruleForm)
      if(res.code === '200'){
        this.tableData = res.data
        this.departTreeList = res.data
      }else{
        this.$message.error(res.msg)
        this.tableData = []
      }
      this.loading = false
    },
    // 新增部门选择上级部门
    checkChange(data,checked, node){
      this.i++;
      if(this.i % 2 === 0){
        if(checked){
          this.$refs.tree.setCheckedNodes([]);
          this.$refs.tree.setCheckedNodes([data]);
        }else{
          this.$refs.tree.setCheckedNodes([]);
        }
      }
      // 将获取的值赋值给输入框
      let res = this.$refs.tree.getCheckedNodes()
      res.forEach((item) => {
        this.ruleForm.groupParentId = item.groupId
        this.ruleForm.groupParentName = item.groupName
      })
    },
    addDepartItem(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.userCode = parseInt(JSON.parse(window.sessionStorage.getItem('userInfo')).userId)
          this.title === '新增部门' ? this.confirmAddDepart() : this.confirmEditDepart()
        } else {
          return false;
        }
      });
    },
    // 确认添加部门信息
    async confirmAddDepart(){
      const res = await addDepart(this.ruleForm);
      if(res.code == '200'){
        this.$message.success('新增成功')
        this.clearInputContent()
        this.changeVisible = false
        this.$router.back()
      }else{
        this.$message.error(res.msg)
      }
    },
    // 修改部门信息
    async confirmEditDepart(){
      let date = dateFilter(new Date);
      this.ruleForm.createdTime = date;
      const res = await changeDepart(this.ruleForm);
      if(res.code === '200'){
        this.$message.success('修改成功')
        this.changeVisible = false
        this.$router.back()
      }else{
        this.$message.error(res.msg)
      }
    },
    // 清除输入框内容
    clearInputContent(){
      for(let key in this.ruleForm){
        this.ruleForm[key] = ''
      }
    },
    // 关闭 dialog
    handleClose(){
      this.dialogVisible = false
    }
  }

}

</script>
<style scoped>
::v-deep .el-form{
  width: 50%;
  margin: 0 auto;
}
</style>
<style lang='scss' scoped>
.footer-btn{
  text-align: center;
}
</style>
